// @lumi/app-kit shared i18n vocabulary (ADR 0026 §7) — locale sv.
// Byte-identical common.*/errors.* used across >=3 apps + owned by app-kit components.
// Apps merge appKitMessages under their own catalog; the no-shadow check forbids an
// app from redefining these keys. Generated from the per-app catalogs.
export default {
  // The sidebar's account menu + history buttons (suite design foundation, spec §4):
  // byte-identical across every chrome, so owned here rather than by nine app catalogs.
  accountMenu: {
    profile: 'Min profil',
    settings: 'Inställningar',
    theme: 'Utseende',
    themeLight: 'Ljust',
    themeDark: 'Mörkt',
    support: 'Support',
    back: 'Bakåt',
    forward: 'Framåt',
    collapseSidebar: 'Fäll ihop sidofältet',
    expandSidebar: 'Fäll ut sidofältet',
    // The account row of a phone-only account (issue 698): no name, no address.
    signedIn: 'Inloggad',
  },
  // A sidebar entry another of the viewer's own roles opens (#1028): the
  // greyed entry's hint, its switch dialog, and the role list joiner.
  roleLock: {
    hint: 'Bara som {roles}. Byt roll: nere till vänster, ditt konto → Roll.',
    body: 'Det här området har du som {roles}. Just nu arbetar du som {active}.',
    action: 'Öppna som {role}',
    where: 'Du kan byta roll när som helst: nere till vänster, ditt konto → Roll.',
    listOr: '{list} eller {last}',
  },
  common: {
    // Every DateField's calendar and typing hint (issue 823; People's own until then).
    datePicker: {
      open: 'Öppna kalendern',
      previousMonth: 'Föregående månad',
      nextMonth: 'Nästa månad',
      month: 'Månad',
      year: 'År',
      clear: 'Rensa datumet',
      dayToken: 'DD',
      monthToken: 'MM',
      yearToken: 'ÅÅÅÅ',
    },
    deactivate: 'Inaktivera',
    revoke: 'Återkalla',
    remove: 'Ta bort',
    actions: 'Åtgärder',
    calendar: 'Kalender',
    cancel: 'Avbryt',
    close: 'Stäng',
    confirmTitle: 'Bekräfta',
    contactSupport: 'Kontakta supporten',
    copyLink: 'Kopiera länk',
    edit: 'Redigera',
    language: 'Språk',
    linkCopied: 'Länk kopierad',
    linkCopyFailed: 'Det gick inte att kopiera länken',
    moduleListHeading: 'Dina moduler',
    moduleTeaserAction: 'Lägg till i faktureringen',
    moduleTeaserHeading: 'Ingår också i lumi',
    moduleTeaserNote: 'Arbetsytans ägare, administratörerna och Billing Managers kan lägga till dessa moduler.',
    moduleTeaserTag: 'Ingår inte i din plan',
    no: 'Nej',
    nothingHere: 'Inget här ännu',
    ok: 'OK',
    refresh: 'Uppdatera',
    retry: 'Försök igen',
    role: 'Roll',
    save: 'Spara',
    search: 'Sök',
    switchModule: 'Byt modul',
    tabsNext: 'Visa nästa flikar',
    tabsPrevious: 'Visa föregående flikar',
    understood: 'Förstått',
    userDeactivated: '{name} (inaktiverat konto)',
    yes: 'Ja',
  },
  errors: {
    // ADR 0036 code-first branch (errorKeyFor): a backend `code` wins over the
    // status. `invalid_credentials` is what every login door answers a bad
    // sign-in with — a bare 401 would otherwise fall through to
    // `errors.unauthorized`, telling someone who mistyped their password that
    // their session expired (issue 364, F10). It never lets a caller tell an
    // unknown account apart from a mistyped password — the two answer
    // identically — so the copy names both fields.
    // `MASTER_INVITE_REJECTED` is people-api's fallback when the identity
    // service refuses an invitation payload without a code of its own (issue
    // 364, decisions round 1): without an entry here it degrades to the
    // status-derived message, which says nothing about what to look at. Its
    // sibling `MASTER_TENANT_NOT_FOUND` stays local to PersonDetailView on
    // purpose — that one names a next step specific to that screen.
    codes: {
      invalid_credentials: 'Inloggningen misslyckades. Kontrollera din e-postadress och ditt lösenord.',
      MASTER_INVITE_REJECTED: 'Inbjudan avvisades eftersom personens uppgifter inte kunde godtas. Kontrollera e-postadressen och namnet i personposten och försök igen.',
      PERSON_EMAIL_INVALID: 'Den här personen saknar en giltig e-postadress, så ingen inloggning kan bjudas in. Rätta först adressen i personposten.',
      PERSON_PHONE_INVALID: 'Det här mobilnumret är inte giltigt. Ange det i internationellt format, med + och landsnumret, t.ex. +46 70 123 45 67.',
      PERSON_ACCESS_PHONE_TAKEN: 'En annan person har redan en inloggning med det här mobilnumret, eller håller på att få en. Ett nummer, en person.',
      PHONE_ACCESS_UNAVAILABLE: 'Åtkomst via mobilnummer är inte tillgänglig här — för den här arbetsytan eller för det här numrets land. Använd en e-postadress i stället.',
      SUITE_ROLE_NEEDS_EMAIL: 'Den här personen loggar in med ett mobilnummer och har ingen e-postadress. Svitroller får juridisk e-post, fakturor och samtyckesmejl och behöver därför en adress.',
      OWNER_NEEDS_EMAIL: 'Den här personen loggar in med ett mobilnummer och har ingen e-postadress. Ägaren får juridisk e-post och avtalsmejl, så ägarskap kräver en adress.',
      RECORD_CHANGED: 'Någon annan har ändrat posten medan du redigerade den. Ladda om den – det du skrivit sparas som utkast.',
    },
    appUpdatedBody: 'Sidan kunde inte laddas färdigt eftersom appen har uppdaterats. Ladda om för att fortsätta.',
    appUpdatedTitle: 'En ny version är tillgänglig',
    conflict: 'Åtgärden står i konflikt med aktuellt läge. Ladda om och försök igen.',
    contactSupport: 'Kontakta supporten',
    exhausted: 'Det här verkar verkligen vara trasigt. Vi beklagar. Kontakta supporten.',
    failedTitle: 'Åtgärden misslyckades',
    forbidden: 'Du har inte behörighet för den här åtgärden.',
    loadFailedTitle: 'Kunde inte laddas',
    network: 'Ingen anslutning till servern. Kontrollera din internetanslutning.',
    notFound: 'Det begärda objektet hittades inte.',
    rateLimited: 'För många förfrågningar. Vänta en stund och försök igen.',
    recordChangedReload: 'Någon annan sparade posten efter att du öppnade den, så din ändring tillämpades inte. Ladda om för att se den aktuella versionen – det du skrivit finns kvar och kan återställas.',
    refreshFailedTitle: 'Det här kan vara inaktuellt',
    server: 'Ett serverfel uppstod. Försök igen senare.',
    timeout: 'Servern svarade inte i tid. Försök igen om en stund.',
    unauthorized: 'Din session har gått ut. Logga in igen.',
    unexpected: 'Något gick fel när det här skulle visas. Försök igen.',
    validation: 'Kontrollera dina uppgifter.',
  },
  notReady: {
    title: 'Det här är inte redo för dig än',
    body: 'Din arbetsyta förbereds fortfarande. Vi tar dig tillbaka till workspace om 5 sekunder.',
  },
  // The workspace this app was opened on does not exist, or can no longer be
  // reached (issue 364, F57). ONE message for BOTH causes on purpose: ats-api
  // answers a suspended tenant and an unknown slug identically, and splitting
  // the copy would confirm which workspaces exist. `body` therefore names no
  // cause, and nothing on the page names a workspace, a slug or a person.
  tenantUnavailable: {
    title: 'Den här arbetsytan går inte att nå',
    body: 'Den här arbetsytan finns inte eller går inte att nå just nu – kontrollera adressen du öppnade.',
    accountLead: 'Dina egna uppgifter och dina fakturor finns kvar i ditt lumi-konto.',
    accountCta: 'Till ditt lumi-konto',
    supportLead: 'Om det här är ett misstag, hör av dig så löser vi det tillsammans.',
    // The signed-in person's own membership is gone (issue 669): a revoked demo guest,
    // or a demo that ended under an open tab.
    ended: {
      title: 'Du har inte åtkomst till den här arbetsytan',
      body: 'Du är inloggad, men är inte (eller inte längre) medlem i den här arbetsytan. Om du var gäst i en demo har demon avslutats eller din inbjudan har dragits tillbaka.',
      accountLead: 'Ditt eget lumi-konto påverkas inte.',
    },
  },
  billing: {
    banner: {
      suspendedTitle: 'Arbetsytan är låst',
      suspendedMessage: 'Den här arbetsytan är avstängd. Kontakta oss för att återställa åtkomsten.',
      lockedBody: 'Den här arbetsytan har låsts på grund av ett olöst faktureringsproblem. Åtkomsten till alla moduler är för närvarande pausad.',
      lockedSupportLead: 'Kontakta vårt supportteam för att återställa åtkomsten:',
      lockedSupportCta: 'Kontakta support',
      lockoutOn: 'Annars låses arbetsytan den {date}.',
      fixCardTitle: 'Uppdatera ditt kort',
      fixCardBody: 'Din senaste betalning nekades eftersom ditt kort inte godtogs.',
      fixCardCta: 'Uppdatera kort',
      softDeclineTitle: 'Säkerställ din betalning',
      softDeclineBody: 'Vi kunde inte dra din senaste betalning och försöker igen automatiskt. Se till att din betalningsmetod har tillräckligt med pengar.',
      softDeclineCta: 'Granska betalningsmetod',
      scaTitle: 'Bekräfta din betalning',
      scaBody: 'Din bank behöver att du bekräftar den här betalningen innan vi kan dra den.',
      scaCta: 'Bekräfta betalning',
      recoveryError: 'Betalningen kunde inte startas just nu. Försök igen om en stund.',
      chargebackTitle: 'Reglera din återförda betalning',
      chargebackBody: 'Din bank återförde en betalning, så den är obetald igen. Lägg till en betalningsmetod för att reglera den.',
      chargebackCta: 'Lägg till betalningsmetod',
      trialTitle: 'Lägg till en betalningsmetod',
      trialBody: 'Din testperiod har tagit slut. Lägg till en betalningsmetod för att hålla den här arbetsytan aktiv.',
      trialCta: 'Lägg till betalningsmetod',
      reviewTitle: 'Granska din fakturering',
      reviewBody: 'Den här arbetsytan behöver en faktureringsåtgärd för att förbli aktiv.',
      reviewCta: 'Hantera fakturering',
      contactTitle: 'Kontakta din administratör',
      contactBody: 'Ett faktureringsproblem behöver åtgärdas för att hålla den här arbetsytan aktiv.',
    },
  },
  legalNoticeBanner: {
    title: 'Juridiska meddelanden behöver din uppmärksamhet',
    employeeBody: 'Inbjudningar är pausade tills sekretessmeddelandet för anställda är komplett.',
    candidateBody: 'Karriärportalen är offline tills meddelandena för kandidater är kompletta.',
    imprintBody: 'Karriärportalen är offline tills juridisk information har sparats.',
    candidateImprintBody: 'Karriärportalen är offline tills meddelandena för kandidater är kompletta och juridisk information har sparats.',
    cta: 'Öppna Juridiska meddelanden',
  },
  // The one "needs you" strip (issue 713): the list label, the hide control and the
  // per-item sentences. A lone legal item reuses legalNoticeBanner.* word for word.
  needsYou: {
    label: 'Behöver dig fortfarande:',
    hide: 'Dölj',
    timeRules: {
      link: 'Arbetstidsregler',
      cta: 'Granska',
      body: 'Arbetstidsreglerna är inte granskade än. lumi räknar med lagens standardregler och varnar bara tills någon bekräftar att de passar ert företag.',
    },
    legal: { link: 'Fyll i de juridiska meddelandena' },
    billing: {
      link: 'Slutför faktureringen',
      cta: 'Öppna fakturering',
      bodyBoth: 'Lägg till dina fakturauppgifter och en betalningsmetod så att din arbetsyta fortsätter fungera utan avbrott.',
      bodyInvoiceDetails: 'Lägg till dina fakturauppgifter så att dina fakturor utfärdas korrekt.',
      bodyPaymentMethod: 'Lägg till en betalningsmetod så att din arbetsyta fortsätter fungera utan avbrott.',
    },
  },
  // Consented temporary support access (ADR 0041): the marker every module
  // chrome shows beside the tenant name while a supporter is inside a grant.
  supportAccess: {
    label: 'Supportåtkomst',
    until: 'Tillfällig supportåtkomst till {until} — allt du gör här registreras i den här tenantens granskningslogg.',
  },
  // Idle session timeout (issue 265). Owned by app-kit's IdleLogoutGuard, except
  // idleSignedOut — the login pages (workspace, system-admin) render that after
  // the bounce, and it is the same suite-wide policy statement, so it stays in one
  // place rather than drifting between the two login surfaces.
  session: {
    idleTitle: 'Är du kvar?',
    idleBody: 'Du har varit inaktiv en stund. För din säkerhet loggar vi ut dig automatiskt.',
    idleStay: 'Förbli inloggad',
    idleSignedOut: 'Du loggades ut efter {minutes} minuters inaktivitet. Logga in igen.',
  },
  // Browser form drafts (owner-stamped, 7 days, typed values only — app-kit
  // utils/formDraftStorage.ts). Owned by app-kit's DraftBanner and by the
  // sign-out warning every module chrome shows, so the wording lives here instead
  // of drifting across five app catalogs.
  formDrafts: {
    bannerTitle: 'Osparat utkast',
    bannerSavedAt: 'Sparat på den här enheten: {when}',
    bannerRecordChanged: 'Posten har ändrats sedan det här utkastet. Återställ lägger bara tillbaka de fält du har ändrat.',
    restore: 'Återställ',
    discard: 'Ta bort',
    closeTitle: 'Förkasta det du skrivit i ”{form}”?',
    closeBody: 'Osparade uppgifter går förlorade.',
    closeConfirm: 'Förkasta',
    closeCancel: 'Fortsätt redigera',
    recordChangedTitle: 'Ändrad av någon annan',
    reload: 'Ladda om',
    forms: {
      'apprentice': {
        planStation: 'Utbildningsplanens station',
        skillCatalogue: 'Kompetenskatalog',
        trainingData: 'Utbildningsuppgifter',
      },
      'ats': {
        workflowEditor: 'Arbetsflödesredigerare',
      },
      'backoffice': {
        applicationForm: 'Ansökan',
        createApplication: 'Ny ansökan',
        customField: 'Anpassat fält',
        customFields: 'Anpassade fält',
        emailSettings: 'E-postinställningar',
        jobAd: 'Platsannons',
        jobAdTemplate: 'Mall för platsannons',
        jobEdit: 'Tjänst',
        portalSettings: 'Inställningar för karriärportal',
        ravenBatchPublish: 'Batchpublicering av annonser',
        ravenPublish: 'Annonspublicering',
        role: 'Roll',
        suggestion: 'Förslag',
        supportTicket: 'Supportärende',
        supportTicketReply: 'Svar på supportärende',
        talentEdit: 'Talangprofil',
        workflowAction: 'Arbetsflödesåtgärd',
        workflowCondition: 'Arbetsflödesvillkor',
        workflowGuard: 'Arbetsflödesvakt',
        workflowState: 'Arbetsflödesstatus',
        workflowTransition: 'Arbetsflödesövergång',
      },
      'people': {
        bankAccount: 'Bankkonto',
        companyProfile: 'Företagsprofil',
        employmentContract: 'Anställningsavtal',
        myProfile: 'Min profil',
        onboardingTemplate: 'Onboardingmall',
        oneTimePayment: 'Engångsbetalning',
        orgUnit: 'Organisationsenhet',
        person: 'Person',
        taxProfile: 'Skatteprofil',
        wageAssignment: 'Löneutmätning',
      },
      'system-admin': {
        fileQuota: 'Filkvot',
        skillDetail: 'Kompetensdetalj',
        suggestionNotes: 'Anteckningar om förslag',
      },
      'time': {
        blueprint: 'Arbetstidsmodell',
        leaveRequest: 'Ledighetsansökan',
        leaveType: 'Frånvarotyp',
        orgGroup: 'Organisationsgrupp',
        project: 'Projekt',
        role: 'Roll',
        userProfile: 'Användarprofil',
        weekGrid: 'Veckorutnät',
        workTimeModel: 'Arbetstidsmodell',
      },
      'user': {
        ssoSettings: 'SSO-inställningar',
      },
      'workspace': {
        billingProfile: 'Faktureringsprofil',
        wizardGeneral: 'Installationsguide',
      },
    },
  },
  // Suite-wide legal footer (issue 221): the § 5 DDG imprint and the privacy
  // notice of the Lumi entity live once on the marketing site, and every app
  // links to them through the shared LegalLinksFooter. The wording is
  // byte-identical everywhere, so it belongs to app-kit rather than to any app.
  legal: {
    imprint: 'Juridisk information',
    privacy: 'Integritet',
    terms: 'Allmänna villkor',
    label: 'Juridisk information',
    employeeNotice: 'Integritet hos {company}',
  },
  dataImport: {
    run: {
      stepsLabel: 'Importens steg',
      steps: {
        file: 'Fil',
        questions: 'Frågor',
        review: 'Granska',
        commit: 'Överför',
      },
      toOverview: 'Till översikten',
      reading: '{file} läses',
      checking: 'Raderna kontrolleras',
      committing: 'Data överförs',
      tables: '{count} tabell | {count} tabeller',
      rows: '{count} rad | {count} rader',
      aiOn: 'Lumi förbättrar mappningen',
      aiOff: 'Mappning enligt regler',
      proposalByRules: 'Förslag enligt regler · {reason}',
      reasons: {
        off: 'Lumi var avstängd för den här filen.',
        disabled: 'AI är avstängt i den här arbetsytan.',
        quota: 'AI-kvoten var slut.',
        no_key: 'Ingen AI-nyckel är angiven.',
        error: 'Lumi gick inte att nå just nu.',
      },
    },
    title: 'Dataimport',
    intro: 'Importera befintliga data från ett gammalt system: ladda upp en fil, granska fältmappningen, kontrollera testkörningen och bekräfta sedan.',
    backToList: 'Tillbaka till översikten',
    sourceSystem: 'Källsystem',
    cancelled: 'Denna import avbröts.',
    steps: {
      upload: 'Uppladdning',
      analysis: 'Analys',
      mapping: 'Mappning',
      dryRun: 'Testkörning',
      commit: 'Bekräftelse',
    },
    status: {
      uploaded: 'Uppladdad',
      analyzing: 'Analyserar',
      mapping_ready: 'Granska mappning',
      dry_running: 'Testkörning pågår',
      dry_run_ready: 'Testkörning klar',
      committing: 'Bekräftar',
      completed: 'Slutförd',
      failed: 'Misslyckad',
      cancelled: 'Avbruten',
    },
    formats: {
      csv: 'CSV',
      xlsx: 'Excel',
      json: 'JSON',
      sql_dump: 'SQL-dump',
      hropen: 'HR Open JSON',
    },
    transforms: {
      none: 'Direkt',
      date: 'Datum',
      number: 'Tal',
      boolean: 'Ja/Nej',
      enum_map: 'Värdemappning',
      split_name: 'Dela namn',
      concat: 'Slå ihop',
      const: 'Konstant',
      skip: 'Ignorera',
    },
    upload: {
      sourceSystem: 'Källsystemets namn',
      sourceSystemHint: 'Sparas som referens så att en ny import av samma fil uppdaterar poster i stället för att duplicera dem.',
      sourceSystemPlaceholder: 't.ex. gammalt_hr_system',
      sourceSystemFirst: 'Ange källsystemet först.',
      dropHint: 'Dra en fil hit eller bläddra',
      formats: 'CSV, Excel (XLSX), JSON eller SQL-dump — max 50 MB',
      browse: 'Välj fil',
      uploading: 'Laddar upp …',
    },
    running: {
      uploaded: 'Startar analys …',
      analyzing: 'Analyserar fil …',
      dry_running: 'Testkörning pågår …',
      committing: 'Skriver data …',
      hint: 'Stora filer kan ta några minuter. Sidan uppdateras automatiskt.',
    },
    failed: {
      title: 'Importen misslyckades',
      generic: 'Filen kunde inte läsas.',
      unsupported: 'Det här filformatet stöds inte. Använd CSV, Excel, JSON, en SQL-dump eller HR Open.',
      empty: 'Filen innehåller inga rader.',
      enqueue: 'Importen kunde inte startas. Försök igen om en stund.',
      dryRun: 'Raderna kunde inte kontrolleras. Börja om med filen från översikten.',
      commit: 'Uppgifterna kunde inte överföras. Börja om med filen från översikten.',
    },
    questions: {
      quoted: '”{value}”',
      saving: 'Kopplingen sparas',
      companionRunning: '{entity} skapas i {module}',
      reading: {
        title: 'Det här känner vi igen',
        taken: 'Tas med',
        notTaken: 'Tas inte med',
        from: 'från kolumn',
        nothingTaken: 'Ingenting från den här filen tas med ännu.',
        split: '(delad)',
        joined: '(sammanfogad)',
        reasons: {
          other_entry: 'hör till en annan post',
          never_importable: 'importeras aldrig',
          no_field: 'inget passande fält',
        },
        wrong: 'Stämmer något inte?',
        editMapping: 'Ändra kopplingen i detalj',
        improve: 'Låt Lumi förbättra den',
        improveConflict: 'Filen går inte att läsa om just nu. Ladda om sidan och försök igen.',
      },
      extras: {
        title: 'Filen innehåller även andra uppgifter. Ska de tas med?',
        columns: 'Från {columns}.',
        companion: 'Från {columns}: {count} nytt värde som skapas i {module} innan resten av uppgifterna kommer. | Från {columns}: {count} nya värden som skapas i {module} innan resten av uppgifterna kommer.',
        companionTruncated: 'Från {columns}: minst {count} nytt värde som skapas i {module} innan resten av uppgifterna kommer. | Från {columns}: minst {count} nya värden som skapas i {module} innan resten av uppgifterna kommer.',
        asOwnEntry: 'Det som tas med dyker upp i flytten som en egen post (från {file}).',
        forbidden: 'Du saknar behörighet i {module} för det här. Importen fortsätter utan de här uppgifterna.',
        unavailable: '{module} svarade inte just nu. Importen fortsätter utan de här uppgifterna.',
      },
      list: {
        heading: 'Vi har inget mer att fråga dig | Vi behöver fråga dig om en sak | Vi behöver fråga dig om {count} saker',
      },
      uncertain: {
        title: 'Kolumnen {column} innehåller {samples} — är det {field}?',
        titleNoSamples: 'Kolumnen {column} — är det {field}?',
        yes: 'Ja, det är {field}',
        no: 'Nej, det är …',
        pickField: 'Välj ett fält',
        skip: 'Ta inte med',
      },
      required: {
        title: 'För {entity} behöver vi {field}. Varifrån kommer det?',
        forAll: 'Samma för alla:',
        pickValue: 'Välj ett värde',
        inColumn: 'Finns i kolumn …',
        pickColumn: 'Välj en kolumn',
        none: 'Filen har inte det',
      },
      supervisor: {
        title: 'Vem är chef för de här personerna?',
        fromColumn: 'Från kolumnen',
        columnHint: 'Anställningsnumret måste finnas i den här filen eller redan i Personal.',
        onePerson: 'En person för alla:',
        pickPerson: 'Välj en person',
        noPersons: 'Du kan inte välja en person för alla: personlistan är inte tillgänglig för dig här.',
        self: 'Alla är sin egen chef tills vidare',
        selfHint: 'Organisationsschemat bygger du sedan upp i Personal.',
        deferred: 'Tills vidare utan chef',
        deferredHint: 'Rader utan chef markerar vi vid kontrollen.',
        personsTruncated: 'De första 500 personerna efter namn; anställningsnumret för den du söker kan du också ange via en kolumn.',
      },
      enum: {
        title: 'I {column} finns värden som {module} inte känner till',
        count: '{count}×',
        pick: 'Välj',
        leaveEmpty: 'lämna tomt',
        rowLabel: 'Koppling för {value}',
        viaCompanion: 'skapas i {module}',
      },
      date: {
        title: 'Hur är datumet i {column} uppbyggt?',
        day: 'dag',
        month: 'månad',
        year: 'år',
        yearShort: 'år (2 siffror)',
        example: '{sample} läses som {date}',
      },
      fold: {
        title: 'Alla kopplingar i detalj ({count} kolumn) | Alla kopplingar i detalj ({count} kolumner)',
        show: 'Visa',
        hide: 'Dölj',
      },
      verdict: {
        title: 'Den här filen kan inte bli {entry}',
        missing: 'Saknas: {fields}. Ingen kolumn i filen kan ge det.',
        extraHint: 'Om du bockar ur de extra uppgifterna ovan gäller det inte längre.',
        elsewhere: 'Välj en annan post:',
        readAs: 'Läs som {entry}',
        otherModule: 'Hör filen hemma i en annan modul, kasta den här och lägg den där den hör hemma.',
        discard: 'Kasta filen',
      },
      footer: {
        next: 'Därefter kontrollerar vi varje rad. Inget sparas ännu.',
        nextCreating: 'Först skapar vi {count} nytt värde ({what}) i {module}, sedan kontrollerar vi varje rad i filen. | Först skapar vi {count} nya värden ({what}) i {module}, sedan kontrollerar vi varje rad i filen.',
        back: 'Tillbaka',
        confirm: 'Nästa: kontrollera uppgifterna',
        confirmCreating: 'Nästa: skapa och kontrollera',
        open: 'En fråga är fortfarande öppen | {count} frågor är fortfarande öppna',
        withoutThem: 'Du kan fortsätta utan de här uppgifterna.',
      },
    },
    mapping: {
      hint: 'Granska den föreslagna mappningen: ett mål per tabell och ett fält per kolumn. Markerade rader är osäkra förslag.',
      targetEntity: 'Mål',
      skipTable: 'Importera inte',
      skippedTable: 'Denna tabell importeras inte.',
      ignoreColumn: 'Ignorera',
      sourceColumn: 'Kolumn',
      sample: 'Exempelvärden',
      targetField: 'Målfält',
      transform: 'Transformering',
      preview: 'Förhandsvisning',
      rowCount: '{count} rader',
      patternHint: 'Datummönster, t.ex. DD.MM.YYYY',
      multiTargetHint: 'Mål {index} av {total} — samma fil fyller flera mål',
      valueMap: 'Mappa värden',
      valueMapHint: 'Mappa källvärdena till de värden som tillåts i systemet. Omappade värden ger ett fel per rad i testkörningen. Baserat på upp till 20 distinkta exempelvärden i kolumnen.',
      valueMapUnmapped: '— inte mappat —',
      addColumnRow: 'Mappa en kolumn igen',
      customFieldBadge: 'Eget fält',
      createCustomField: 'Skapa nytt eget fält…',
      confirm: 'Bekräfta mappning & starta testkörning',
    },
    report: {
      dryRunHint: 'Testkörning — inget har skrivits ännu. Kontrollera antal och fel innan du bekräftar.',
      completedHint: 'Importen är klar. Datan har skrivits.',
      created: 'Nya',
      updated: 'Uppdaterade',
      skipped: 'Överhoppade',
      errors: 'Fel',
      errorList: '{count} fel',
      downloadErrors: 'Ladda ner alla fel',
      row: 'Rad',
      errorMessage: 'Meddelande',
      backToMapping: 'Tillbaka till mappningen',
      commit: 'Bekräfta data',
      commitConfirmTitle: 'Bekräfta data?',
      commitConfirmBody: 'Importen skriver nu till denna modul. Nya poster skapas, befintliga uppdateras. Detta kan inte ångras automatiskt.',
      commitStarted: 'Bekräftelsen har startat – data skrivs nu.',
    },
    review: {
      title: 'Det här hamnar i systemet. Vill du ändra något?',
      filterLabel: 'Filtrera rader',
      note: 'Ändringar gäller bara den här importen. Din fil förblir som den är.',
      row: 'Rad',
      status: 'Status',
      choose: 'Välj …',
      yes: 'Ja',
      no: 'Nej',
      noRows: 'Inga rader för det här urvalet.',
      rowsNoun: 'Rader',
      tiles: {
        new: 'Nya',
        updated: 'Uppdaterade',
        toClear: 'Att reda ut',
        newNote: '{things} skapas',
        updatedNote: 'finns redan, fält som saknas fylls i',
        toClearNote: 'lämnas annars utanför',
      },
      leftOut: '{count} rad utelämnad | {count} rader utelämnade',
      filter: {
        all: 'Alla',
        skipped: 'Utelämnade',
      },
      statuses: {
        new: 'ny',
        updated: 'uppdaterad',
        open: 'öppen',
        corrected: 'rättad',
        skipped: 'utelämnad',
      },
      fixField: 'Rätta {field} på rad {row}',
      reasonOf: 'Varför rad {row} är öppen',
      popoverLabel: 'Rad {row}: vad som är fel',
      mean: 'Menade du {value}?',
      accept: 'Använd {value}',
      findPerson: 'Sök person …',
      pickPerson: 'Välj en person',
      setForAll: 'Ange för alla {count} lika',
      skipRow: 'Utelämna raden',
      leaveEmpty: 'Lämna fältet tomt för den här raden',
      undo: 'Ångra',
      reason: {
        required: '{field} saknas',
        missing: 'Ett obligatoriskt värde saknas',
        invalid: 'Värdet passar inte',
        notFound: '{ref} hittades inte',
        notFoundAny: 'Hänvisningen hittades inte',
        ambiguous: 'Hänvisningen är inte entydig',
        emailLinked: 'Den här e-postadressen hör till en inloggning',
        general: 'Raden importerades inte',
        skipped: 'Raden utelämnad',
      },
      changes: '{count} ändring noterad | {count} ändringar noterade',
      openRows: '{count} rad kvar att reda ut | {count} rader kvar att reda ut',
      footer: {
        unchecked: '{changes} · {open}. Kontrollera först igen, importera sedan.',
        withdrawn: 'Alla ändringar är ångrade. Kontrollera först igen, importera sedan.',
        checked: '{open}. Du kan också importera nu; den här raden lämnas då utanför. | {open}. Du kan också importera nu; de här {count} lämnas då utanför.',
        clear: 'Allt är utrett.',
      },
      back: 'Tillbaka till frågorna',
      recheck: 'Kontrollera igen',
      commit: 'Importera {count} {things}',
      truncated: {
        all: 'Visar {shown} av {total} rader; alla {open} att reda ut är med.',
        some: 'Visar {shown} av {open} rader att reda ut – resten finns i felfilen.',
      },
      notice: {
        movedOn: 'Importen har gått vidare under tiden. Sidan visar nu hur det ser ut.',
        cell: 'Den här cellen kan inte ändras här.',
        value: 'Värdet passar inte.',
        generic: 'Ändringen kunde inte sparas.',
        notChecked: 'Det finns ändringar som kontrollen inte har sett än. Kontrollera igen och importera sedan.',
      },
      commitConfirmOpen: '{count} rad lämnas utanför och listas efteråt. | {count} rader lämnas utanför och listas efteråt.',
    },
    // An import report's error row, worded from the facts the module sent (rowErrorText.ts).
    rowErrors: {
      required: '{field} är tomt, men varje rad behöver ett värde.',
      unknownField: '{field} kan inte importeras här.',
      invalidEnum: '”{value}” är inget giltigt värde för {field}. Giltiga värden: {allowed}.',
      // With the review\'s handles: the cell holds the way out.
      invalidEnumCell: '”{value}” är inget giltigt värde för {field}. Giltiga värden: {allowed}. Välj ett tillåtet värde i cellen.',
      unresolved: {
        person: 'Ingen person hittades med {keys} ”{value}”.',
        supervisor: 'Ingen chef hittades med {keys} ”{value}”.',
        functionalSupervisor: 'Ingen funktionell chef hittades med {keys} ”{value}”.',
        orgUnit: 'Ingen org-enhet hittades med {keys} ”{value}”.',
        parentOrgUnit: 'Ingen överordnad org-enhet hittades med {keys} ”{value}”.',
      },
      supervisorRequired: 'Ingen chef hittades med {keys} ”{value}”, och personen har ingen ännu. Varje aktiv person behöver en: importera chefen först eller välj en som redan finns.',
      unknownEntity: 'Den här typen av data kan inte importeras här.',
      emailLinked: 'Personen loggar in i lumi med den här e-postadressen, så importen ändrar den inte. Adressen förblir som den är i inloggningen – lämna fältet tomt för den här raden för att importera resten.',
      supervisorMissing: 'Varje aktiv person behöver en chef, och den här personen har ingen. Ange en i filen eller lägg upp chefen först.',
      transformFailed: '”{value}” i kolumnen {field} kunde inte omvandlas. Kontrollera formatet under ”Transformering” i mappningssteget.',
      transformFailedNoValue: 'Ett värde i kolumnen {field} kunde inte omvandlas. Kontrollera formatet under ”Transformering” i mappningssteget.',
      unknown: 'Raden importerades inte. Detaljerna finns i felfilen.',
      skippedByUser: 'Du utelämnade den här raden, så den importeras inte.',
      requiredAny: 'I den här raden saknas ett obligatoriskt värde.',
      invalidEnumAny: 'Ett värde i den här raden är inte ett av de tillåtna värdena.',
      unknownFieldAny: 'Ett fält i den här raden kan inte importeras här.',
      unresolvedAny: 'Det som den här raden hänvisar till hittades inte. Skapa det först eller utelämna raden.',
      unresolvedLocal: '{thing}: ”{value}” hittades inte. Skapa posten först eller utelämna raden.',
      unresolvedUser: 'Ingen person i den här arbetsytan matchar raden.',
      invalidTime: 'Tiderna i den här raden stämmer inte med varandra.',
      invalidState: 'Statusen i den här raden finns inte i det publicerade flödet.',
      stateChanged: 'Flödet ändrades medan raden importerades. Kontrollera igen.',
      invalidCustomValue: 'Värdet för ett eget fält i den här raden passar inte.',
      ambiguous: {
        collision: '{ref}: ”{value}” passar på två olika poster – på en som externt ID, på en annan som {other}. Importen gissar inte: välj rätt post nedan.',
        otherSystem: '{ref}: ”{value}” är inget externt ID från det här källsystemet utan från ”{system}” – och passar dessutom på en post som {other}. Importen gissar inte: importera med källsystemet ”{system}” om samma post avses, eller välj rätt post nedan.',
        holderHasExternalId: '{ref}: ”{value}” passar bara som {other} – och den posten har redan det externa ID:t ”{otherId}” i det här källsystemet. Importen gissar inte: välj ”{otherId}” nedan om den avses.',
      },
      // Without the review's handles (the completed report lists the row; nothing here can be chosen).
      ambiguousPlain: {
        collision: '{ref}: ”{value}” passar på två olika poster – på en som externt ID, på en annan som {other}. Importen gissar inte: gör hänvisningen entydig i filen.',
        otherSystem: '{ref}: ”{value}” är inget externt ID från det här källsystemet utan från ”{system}” – och passar dessutom på en post som {other}. Importen gissar inte: importera med källsystemet ”{system}” om samma post avses, eller gör hänvisningen entydig.',
        holderHasExternalId: '{ref}: ”{value}” passar bara som {other} – och den posten har redan det externa ID:t ”{otherId}” i det här källsystemet. Importen gissar inte: hänvisa med ”{otherId}” om den avses.',
      },
      localRefs: {
        department: 'Avdelning',
        location: 'Plats',
        candidate: 'Kandidat',
        job: 'Tjänst',
        client: 'Kund',
        project: 'Projekt',
        bookingType: 'Bokningstyp',
        leaveType: 'Frånvarotyp',
      },
      refs: {
        person: 'Person',
        supervisor: 'Chef',
        functionalSupervisor: 'Funktionell chef',
        orgUnit: 'Org-enhet',
        parentOrgUnit: 'Överordnad org-enhet',
      },
      supervisorInactive: {
        supervisor: 'Den angivna chefen är inte längre aktiv och kan därför inte leda någon.',
        functional: 'Den angivna funktionella chefen är inte längre aktiv och kan därför inte leda någon.',
      },
      supervisorUnconfirmed: {
        supervisor: 'Den angivna chefen har inte bekräftats av HR ännu och kan därför inte leda någon. Bekräfta chefen i People först.',
        functional: 'Den angivna funktionella chefen har inte bekräftats av HR ännu och kan därför inte leda någon. Bekräfta chefen i People först.',
      },
      datesInverted: 'Datumet under {end} ligger före det under {start}.',
      agreementCodeInvalid: '{field} tillåter bara bokstäver, siffror, ”-”, ”_” och ”.”, högst 60 tecken och inga mellanslag.',
      statusTransition: 'Ett avtal kan inte gå från ”{from}” till ”{to}”.',
      reportingCycle: 'Den här tilldelningen skulle sluta rapportvägen i en cirkel.',
      ambiguousOrgCode: 'Flera org-enheter av olika typ har koden ”{value}”. Hänvisa till rätt enhet med dess externa ID.',
      keys: {
        externalId: 'externt ID',
        employeeNumber: 'anställningsnummer',
        code: 'kod',
      },
    },
    list: {
      title: 'Tidigare importer',
      file: 'Fil',
      system: 'Källsystem',
      status: 'Status',
      created: 'Skapad',
      empty: 'Inga importer ännu.',
      open: 'Öppna',
      delete: 'Ta bort',
      deleteConfirmTitle: 'Ta bort importen?',
      deleteConfirmBody: '”{file}” och alla tillhörande importfiler tas bort. Redan överförda data behålls.',
      deleted: 'Importen ”{file}” har tagits bort.',
    },
  },
  dataExport: {
    title: 'HR Open-export',
    intro: 'Exporterar modulens data som HR Open 4.5 (HR-JSON) — validerad mot standarden.',
    create: 'Skapa export',
    creating: 'Skapar …',
    download: 'Ladda ner',
    password: {
      title: 'ZIP-lösenord — synligt endast nu',
      hint: 'Exporten skapas som en lösenordsskyddad ZIP (AES-256) eftersom den innehåller personuppgifter. Kopiera lösenordet nu — det visas inte igen. Öppna med t.ex. 7-Zip, WinZip eller Keka.',
      copy: 'Kopiera lösenord',
      copied: 'Kopierat',
    },
    empty: 'Inga exporter ännu.',
    columns: {
      standard: 'Standard',
      status: 'Status',
      items: 'Poster',
      created: 'Skapad',
    },
    status: {
      queued: 'I kö',
      generating: 'Genererar',
      completed: 'Slutförd',
      failed: 'Misslyckad',
    },
  },
  // The demo's module picker (ADR 0083): the fork offers it on entry, the bar's
  // reset confirmation again. A locked module is booked (or core) and always in.
  // RoleNameTranslations.vue (ADR 0086): a custom role's names in other
  // languages, or the notice a system role gets instead.
  roleNames: {
    translations: 'Översättningar',
    translationsHint: 'Namnet på andra språk. Tomma fält visar namnet ovan.',
    systemHint: 'Systemroll: lumi namnger den på alla språk. Namn och beskrivning kan inte ändras, behörigheterna kan det.',
  },
  demoModules: {
    legend: 'Moduler i demot',
    booked: 'Bokad — alltid med',
  },
  demoStage: {
    label: 'Demo',
    viewingAs: 'Visa som',
    personaPlaceholder: 'Välj en roll',
    persona: {
      team_lead: 'Teamledare',
      employee: 'Medarbetare',
      hr_admin: 'HR-administratör',
      recruiter: 'Rekryterare',
      ats_admin: 'ATS-administratör',
      council_member: 'Medlem i personalrådet',
      apprentice: 'Lärling',
      trainer: 'Handledare',
    },
    personaDoes: {
      team_lead: 'Beslutar om frånvaro- och rättelseärenden och bedömer ansökningar.',
      employee: 'Bokar arbetsdagar, ansöker om frånvaro och låter rätta registreringar.',
      hr_admin: 'Skapar personer, projekt och jobb.',
      recruiter: 'För ansökningar genom den första granskningen och bokar intervjuer.',
      ats_admin: 'Beslutar om frånvaro, bedömer ansökningar och skapar jobb.',
      council_member: 'Avger personalrådets röst om jobb och erbjudanden.',
      apprentice: 'Bockar av steg i utbildningsplanen och bokar arbetsdagar.',
      trainer: 'Granskar lärlingars rapporter och bokar deras prov.',
    },
    picker: {
      title: 'Vems perspektiv vill du se demot från?',
      subtitle: '{count} kollegor på {company}. Varje roll har egna uppgifter — dina bockar sparas per roll.',
      taskCount: '{total} uppgift | {total} uppgifter',
      current: 'Aktuell vy',
    },
    intro: {
      lead: 'är hittepå. Även personerna i det är påhittade. Allt under listen hör till demot — där tar du på dig olika roller. Ditt riktiga konto påverkas inte.',
      bridgeBefore: 'Du kan avsluta demon när som helst. All data nedan tas då bort och du kan sätta upp ',
      bridgeAfter: ' för din egen organisation.',
      close: 'Stäng',
    },
    reset: 'Återställ demot',
    guestMarker: 'Gäst',
    guestWelcome: {
      invitedBy: 'En kollega på {workspace} har bjudit in dig till den här demon.',
      invitedAnon: 'En kollega har bjudit in dig till den här demon.',
      body: '{company} är påhittat och delas med alla andra i den här demon. Andra kan redan ha provat saker, så det kan se halvspelat ut. ”{reset}” ger alla en nystart. Din åtkomst upphör när demon avslutas. Även personerna i det är påhittade.',
    },
    cancel: 'Avbryt',
    rebuildFailed: 'Demot kunde inte byggas om. Försök igen.',
    resetConfirm: {
      title: 'Återställa demot?',
      body: 'Allt som {company} innehåller just nu kastas — även det du eller dina kollegor har matat in, och allas framsteg på resorna — och demot byggs upp igen från början. Alla i demon börjar om; ingens åtkomst ändras.',
      cta: 'Återställ demot',
    },
    // The demo bar's "Invite a colleague" dialog (issue 669).
    guests: {
      entry: 'Bjud in en kollega',
      title: 'Bjud in en kollega',
      subtitle: 'Kollegor du bjuder in ser den här demon som den är och kan prova den själva.',
      close: 'Stäng',
      loading: 'Laddar…',
      retry: 'Försök igen',
      emailLabel: 'E-postadress på jobbet',
      emailPlaceholder: "namn{'@'}foretag.se",
      send: 'Skicka inbjudan',
      sendAgain: 'Skicka igen',
      slotsLeft: '{count} plats kvar | {count} platser kvar',
      exhausted: 'Alla {limit} platser är upptagna. Återkalla en inbjudan nedan för att bjuda in någon annan.',
      invalid: 'Ange en giltig e-postadress.',
      listTitle: 'I den här demon förutom du',
      used: '{used} av {limit} upptagna',
      empty: 'Ingen är inbjuden än.',
      state: {
        invited: 'Inbjuden',
        joined: 'Har gått med',
      },
      revoke: 'Återkalla',
      revoking: 'Återkallar…',
      revokeFor: 'Återkalla åtkomsten för {email}',
      about: {
        title: 'Vad en gäst är',
        sees: 'En gäst ser den här demon precis som den är just nu — även allt du redan har provat. ”{reset}” i fältet ger alla en nystart.',
        resets: 'En gäst kan också återställa demon — för alla i den.',
        limits: 'En gäst kan aldrig avsluta demon eller röra din riktiga arbetsyta.',
        ends: 'Gäster tas bort när demon avslutas.',
      },
      feedback: {
        sent: 'Inbjudan skickad till {email}.',
        resent: 'Inbjudan skickad igen till {email}.',
        undelivered: 'Mejlet till {email} kunde inte levereras. {email} finns på listan och upptar en plats — skicka inbjudan igen för att försöka på nytt.',
        revoked: 'Åtkomsten för {email} har återkallats. Platsen är ledig igen.',
        alreadyMember: '{email} har redan åtkomst till den här arbetsytan.',
        limit: 'Alla platser är upptagna. Återkalla en inbjudan för att bjuda in någon annan.',
        rateLimited: 'För många inbjudningar i dag. Försök igen senare.',
        notLive: 'Inbjudningar fungerar bara medan demon är igång. Den byggs om, eller så har konfigurationen börjat — försök igen när demon är tillbaka.',
        operator: 'Du är inloggad som systemoperatör. Operatörer kan inte bjuda in kollegor till en kunds demo.',
        operatorNotMember: '{email} tillhör ett lumi-operatörskonto, som inte kan gå med i en kunds demo. Bjud in en annan adress.',
        notAPerson: '{email} tillhör ett konto som inte är en person, till exempel ett tjänstekonto. Bjud in en kollegas egen jobbadress.',
        forbidden: 'Bara arbetsytans ägare eller en suite-administratör kan bjuda in kollegor.',
        noticeIncomplete: 'Inbjudningar är pausade tills meddelandena för anställda under Juridisk information är helt ifyllda.',
        accountClosed: 'Det kontot har stängts och kan inte bjudas in.',
        unavailable: 'Inbjudningar kan inte räknas just nu. Försök igen om en stund.',
        revokeFailed: 'Åtkomsten för {email} kunde inte återkallas. Försök igen.',
        generic: 'Något gick fel. Försök igen.',
      },
    },
    leave: 'Avsluta demon',
    continueSetup: 'Fortsätt installationen',
    menu: 'Demoåtgärder',
    signOut: 'Logga ut',
    logoutHint: 'Under demon loggar du ut via dörren eller menyn i demofältet.',
    journey: {
      title: '{name}s resa',
      count: '{done} av {total} klara',
      refresh: 'Uppdatera resan',
      unknown: 'Några kontroller gick inte att nå – senast kända läge visas.',
      yay: 'Det var hela {name}s resa – snyggt jobbat.',
      bridgeAdmin: 'Du har gått igenom alla resor. När du är redo avslutar du demon och sätter upp din egen arbetsyta.',
      bridgeUser: 'Du har gått igenom alla resor. En administratör kan avsluta demon och sätta upp er arbetsyta.',
      blockedReset: 'En återställning tar tillbaka det:',
      blocked: {
        gone: 'Det den här uppgiften behöver finns inte längre.',
      },
      next: 'Härnäst',
      nextCta: 'Öppna i {module}',
      footer: 'Demot bockar av det du gör.',
    },
  },
  // The shared notifications popover (NotificationsPopover.vue). Its own namespace: the
  // apps' `notifications.*` keys (inbox page, preferences) are theirs and stay put.
  notificationsPopover: {
    title: 'Aviseringar',
    empty: 'Du är ikapp.',
    markAllRead: 'Markera alla som lästa',
    markRead: 'Markera som läst',
    markUnread: 'Markera som oläst',
    loading: 'Laddar…',
    openTarget: 'Öppna det länkade objektet',
    goToAll: 'Till aviseringar',
  },
  // The shared place search (PlacePicker.vue). `noMatchAdd` is the wording for hosts whose
  // typed text IS the name (Enter adds it as typed); `noMatch` for hosts that keep it beside the field.
  placePicker: {
    placeholder: 'Sök stad eller kommun …',
    keptHint: 'Sparas precis som du skrev det — utan kopplad ort.',
    searching: 'Söker …',
    typeMore: 'Skriv minst {count} tecken',
    noMatch: 'Ingen träff — din text behålls',
    error: 'Sökningen misslyckades',
    rateLimited: 'För många sökningar — vi försöker igen strax',
    resultsAnnouncement: 'Inga träffar | 1 träff | {count} träffar',
    clear: 'Ta bort ort',
    noMatchAdd: 'Ingen ort hittades — Enter lägger till namnet som det är skrivet',
  },
  // The suite's five app names and their one-line launcher descriptions, in this
  // language. THE one copy: component-lib's registry carries no displayed string, and
  // every app merges this underneath its own messages (ADR 0026 section 7).
  lumiModules: {
    suite: {
      name: 'Hem',
      description: 'Din översikt över arbetsplatsen',
    },
    ats: {
      name: 'Rekrytering',
      description: 'Tjänster, ansökningar och rekryteringsprocessen',
    },
    time: {
      name: 'Tid',
      description: 'Tidrapportering, arbetstidskonton och godkännanden',
    },
    people: {
      name: 'Personal',
      description: 'Personalakter, avdelningar och platser',
    },
    apprentice: {
      name: 'Lärlingar',
      description: 'Digitala utbildningsjournaler och utbildningsplaner',
    },
  },
};
